// eslint-disable-next-line no-restricted-imports
import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { MediaType } from '../MediaType';

export const experimentalEditorStopHeartbeat: ExperimentalMutations['experimentalEditorStopHeartbeat'] =
	(_, { contentId, contentType, heartbeatUserType }, { network: { cfetch } }) => {
		const heartbeatUrl = '/wiki/api/v2/editor/heartbeat/stop';
		const body = {
			dataType: 'json',
			contentId,
			draftType: contentType ?? '',
			heartbeatUserType,
		};
		const requestOptions: RequestInit = {
			method: 'POST',
			body: JSON.stringify(body),
			headers: {
				Accept: MediaType.JSON,
				'Content-Type': MediaType.JSON,
			},
		};

		return cfetch(heartbeatUrl, requestOptions).then(
			() => true,
			() => false,
		);
	};
